import { Button, Icon } from "@validereinc/common-components";
import React from "react";

export const CreateWorkerButton = ({
  isLoading,
  onClick,
  isDisabled,
}: {
  isLoading: boolean;
  onClick: () => void;
  isDisabled?: boolean;
}) => {
  return (
    <Button
      key="create-worker-button"
      variant="primary"
      isLoading={isLoading}
      onClick={onClick}
      slotLeft={
        <Icon
          variant="plus-circle"
          size={24}
        />
      }
      size="x-small"
      disabled={isDisabled}
    >
      Create Worker
    </Button>
  );
};
